import { render, staticRenderFns } from "./shzr.vue?vue&type=template&id=6977a68c&scoped=true"
import script from "./shzr.vue?vue&type=script&lang=js"
export * from "./shzr.vue?vue&type=script&lang=js"
import style0 from "./shzr.vue?vue&type=style&index=0&id=6977a68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6977a68c",
  null
  
)

export default component.exports